import gql from 'graphql-tag'

export const JOKE_FIELDS = gql`
  fragment JokeFields on JokeType {
    id
    text
    credits
    rating
    score
    likesCount
    dislikesCount
    myVote
    isFavorite
    authorName
    isLegacy
    category {
      name
      displayName
    }
    tags {
      slug
      label
      axis
      isSensitive
    }
  }
`

export const JOKES_QUERY = gql`
  query GetJokes($category: String, $count: Int, $offset: Int, $orderBy: OrderBy) {
    jokes(category: $category, count: $count, offset: $offset, orderBy: $orderBy) {
      ...JokeFields
    }
  }
  ${JOKE_FIELDS}
`

export const RANDOM_JOKE_QUERY = gql`
  query RandomJoke($tags: [String], $excludeTags: [String], $scoreFilter: String) {
    randomJoke(tags: $tags, excludeTags: $excludeTags, scoreFilter: $scoreFilter) {
      ...JokeFields
    }
  }
  ${JOKE_FIELDS}
`

export const JOKE_BY_ID_QUERY = gql`
  query JokeById($id: Int) {
    joke(id: $id) {
      ...JokeFields
    }
  }
  ${JOKE_FIELDS}
`

export const SEARCH_JOKES_QUERY = gql`
  query SearchJokes(
    $query: String
    $includeTags: [String]
    $excludeTags: [String]
    $favoritesOnly: Boolean
    $count: Int
    $offset: Int
    $orderBy: OrderBy
  ) {
    searchJokes(
      query: $query
      includeTags: $includeTags
      excludeTags: $excludeTags
      favoritesOnly: $favoritesOnly
      count: $count
      offset: $offset
      orderBy: $orderBy
    ) {
      ...JokeFields
    }
  }
  ${JOKE_FIELDS}
`

// Total number of results for the same filters — drives numbered pagination.
export const SEARCH_JOKES_COUNT_QUERY = gql`
  query SearchJokesCount(
    $query: String
    $includeTags: [String]
    $excludeTags: [String]
    $favoritesOnly: Boolean
  ) {
    searchJokesCount(
      query: $query
      includeTags: $includeTags
      excludeTags: $excludeTags
      favoritesOnly: $favoritesOnly
    )
  }
`

// Per-tag counts contextual to the current selection (live facet numbers).
export const TAG_FACETS_QUERY = gql`
  query TagFacets(
    $query: String
    $includeTags: [String]
    $excludeTags: [String]
    $favoritesOnly: Boolean
  ) {
    tagFacets(
      query: $query
      includeTags: $includeTags
      excludeTags: $excludeTags
      favoritesOnly: $favoritesOnly
    ) {
      slug
      label
      axis
      isSensitive
      jokeCount
    }
  }
`

export const DAILY_JOKE_QUERY = gql`
  query DailyJoke {
    dailyJoke {
      ...JokeFields
    }
  }
  ${JOKE_FIELDS}
`

export const TAGS_QUERY = gql`
  query Tags($axis: String) {
    tags(axis: $axis) {
      slug
      label
      axis
      isSensitive
      jokeCount
    }
  }
`

export const CATEGORIES_QUERY = gql`
  query Categories {
    categories {
      name
      displayName
    }
    total
    newJokesCount
  }
`

export const VOTE_MUTATION = gql`
  mutation Vote($jokeId: Int!, $value: Int!, $anonId: String) {
    vote(jokeId: $jokeId, value: $value, anonId: $anonId) {
      myVote
      joke {
        id
        score
        likesCount
        dislikesCount
      }
    }
  }
`

// The jokes the current user submitted (auth required), most recent first.
export const MY_JOKES_QUERY = gql`
  query MyJokes($count: Int, $offset: Int) {
    myJokes(count: $count, offset: $offset) {
      id
      text
      score
      createdAt
      tags {
        slug
        label
      }
    }
  }
`

// Let the author edit their own submitted joke (mirrors moderator rewrite).
export const EDIT_MY_JOKE_MUTATION = gql`
  mutation EditMyJoke($jokeId: Int!, $newText: String!) {
    editMyJoke(jokeId: $jokeId, newText: $newText) {
      joke {
        id
        text
      }
    }
  }
`

export const SUBMIT_JOKE_MUTATION = gql`
  mutation SubmitJoke($text: String!, $tagSlugs: [String]) {
    submitJoke(text: $text, tagSlugs: $tagSlugs) {
      joke {
        ...JokeFields
      }
    }
  }
  ${JOKE_FIELDS}
`
